import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const search = async (data) => {
  return await httpClient.get('resume_search/', makeFilterParams(data));
};

const getPerson = async (nombre, documento, correo) => {
  return await httpClient.get('search_person/', {
    params: {
      'filter[nombre]': nombre,
      'filter[documento]': documento,
      'filter[correo]': correo,
    },
  });
};

const get = async (id) => await httpClient.get(`search_person/${id}/`);

export { search, getPerson, get };
